import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../../../utils/cn'
import Icon from '../.././../Display/Icon/Icon';

const EditField = ({
  FieldComponent,
  fieldMeta,
  fieldProps,
  id,
  isSaving,
  label,
  onBlur,
  onCancelEdit,
  onChange,
  onSaveEdit,
  setFieldRef,
  value,
  afterLabelContent = null,
}) => {
  const controlsClass = () =>
    cn({
      'flex w-10': true,
      'opacity-50': isSaving,
    });

  const labelWIthControls = () => (
    <div>
      <div className="flex my-1 justify-between">
        <div className="flex">
          <div className="flex-auto capitalize font-semibold text-text-blue text-sm font-heavy-font tracking-normal leading-4">
            {label}
          </div>
          {fieldProps.required && (
            <span className="inline-block text-red text-sm ml-1 transform -translate-y-1 align-text-top">
              *
            </span>
          )}
        </div>
        <div className={controlsClass()}>
          <Icon
            icon="Cross"
            className="bg-red rounded-full p-1 box-border"
            onClick={onCancelEdit}
            id={`${id}-cancel-btn`}
            color="white"
            ariaLabel="Cancel"
            size={18}
            disabled={isSaving}
          />
          <Icon
            icon="Check"
            className="bg-green rounded-full p-1 ml-1 box-border"
            onClick={onSaveEdit}
            id={`${id}-save-btn`}
            color="white"
            ariaLabel="Save"
            size={18}
            disabled={isSaving}
          />
        </div>
      </div>
      <div>{afterLabelContent}</div>
    </div>
  );

  return (
    <FieldComponent
      ref={setFieldRef}
      id={`${id}-field`}
      label={labelWIthControls()}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      {...fieldProps}
      {...fieldMeta}
      omitLabelStyles
      omitRequiredLabel
    />
  );
};

EditField.propTypes = {
  afterLabelContent: PropTypes.node,
  FieldComponent: PropTypes.func.isRequired,
  fieldMeta: PropTypes.object.isRequired,
  fieldProps: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  isSaving: PropTypes.bool.isRequired,
  label: PropTypes.any.isRequired,
  onBlur: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSaveEdit: PropTypes.func.isRequired,
  setFieldRef: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]).isRequired,
};

export default EditField;
